import React from 'react';

const NotFound = () => {
    return <>
    <h1>Not Found 404 .............</h1>
    
    </>
}

export default NotFound;
